import { NotificationConfiguration } from '../notification.templates';

export const RACI_REPORT_COMMENT: NotificationConfiguration = {
  inapp: `{triggeredByName} commented on a decision report`,
  email: {
    ctaKey: 'go_to_decision',
  },
};
